<template>
  <div id="sbmptn">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>SBMPTN</li>
      <li class="active">Daftar Tryout Group SNBT</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Tryout Group SNBT</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Daftar Tryout Group SNBT
            </div>
          </div>
          <div class="panel-body">
            <app-datatable
              :items="tryoutGroups"
              :has-grading="true"
              :has-ranking="true"
              :has-delete="false"
              :has-custom-pagination="true"
							:has-custom-search="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="pagination.perPage"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
              :headers="headers"
              v-on:selected="selectedRow = $event"
              v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
              v-on:gradingTryout="gradingTryout($event)"
              v-on:rankingTryout="rankingTryout($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import TryoutService from '@/services/tryout.js'
import DataTable from '@/components/plugins/DataTable'
import AppSpinner from '@/components/plugins/Spinner'
import AppModal from '@/components/plugins/Modal'
import Moment from 'moment'

export default {
  name: 'user-management',
  components: {
    'app-spinner': AppSpinner,
    'app-datatable': DataTable,
    'app-modal': AppModal
  },
  data: function () {
    return {
      tryoutGroups: [],
      isLoading: false,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc',
      },
      headers: ['Nama', 'Tipe', 'Jenjang', 'Opened At', 'Closed At'],
      headersKey: ['name', 'type', 'level', 'openedAt', 'closedAt'],
      showModal: false
    }
  },
  mounted: function() {
    this.fetchData()
  },
  watch: {
    pagination: function() {
      this.fetchData()
    },
    search: function() {
      console.log(this.search)
    }
  },
  methods: {
    fetchData: function() {
      var params = {
        type: 'SBMPTN',
        variant: 'SCHEDULED',
        status: 'PUBLISHED'
      }

      var context = this
      TryoutService.getListOfTryoutGroups(this.pagination, this.search, params, function(result) {
        context.tryoutGroups = []
        if (result.success) {
          result.data.forEach(function(group) {
            var openedAt = Moment(group.opened_at).format('YYYY-MM-DD')
            var closedAt = Moment(group.closed_at).format('YYYY-MM-DD')

            var row = {
              id: group.id,
              data: [group.name, group.type, group.level, openedAt, closedAt]
            }

            context.pagination.totalPages = group.page
            context.tryoutGroups.push(row)
          })
        }
      })
    },
    gradingTryout: function(row) {
      var todayMilis = new Date().getTime()
      var closedAtMilis = Date.parse(row.data[4])
      var diff = closedAtMilis - todayMilis

      if (diff > 0) {
        window.alert("Tryout belum lewat masa berakhir")
        return;
      }

      var confirmed = window.confirm('Lakukan grading tryout ' + row.data[0] + ' ?')
      if (confirmed) {
        var context = this
        context.isLoading = true

        TryoutService.gradingUtbkScore(row.id, function(result) {
          setTimeout(function() {
            var message = "Proses grading "
            message += result.success ? "berhasil" : "gagal"
            alert(message)
            context.isLoading = false
          }, 3000)
        })
      }
    },
    rankingTryout: function(row) {
      localStorage.setItem('rank_tryoutGroup_name', row.data[0])
      this.$router.push({path: '/sbmptn/top10?group_id=' + row.id})
    }
  }
}
</script>



// WEBPACK FOOTER //
// Sbmptn.vue?b6b203a6